import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Name" field="name" setOrder={setOrder} />
      <THTS txt="Company" field="company_name" setOrder={setOrder} />
      <THTS txt="Email" field="email" setOrder={setOrder} />
      <THTS txt="Phone" field="phone_no" setOrder={setOrder} />
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
